module.exports = __webpack_public_path__ + "img/phone-vector3.956c5261.svg";